(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hh-pantry-notes')) {
  customElements.define('hh-pantry-notes', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('.hh-pantry-notes__slide')];
      this.control = this.querySelector('button');
      this.progress = this.querySelector('.hh-pantry-notes__progress');
      this.counter = this.querySelector('[data-note-number]');
      this.index = 0;
      this.elapsed = 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.events = new AbortController();
      if (!this.control || this.slides.length < 2) return;
      this.sync();
      this.control.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, {signal:this.events.signal});
      this.reduced.addEventListener('change', (event) => { if (event.matches) { this.paused = true; this.sync(); } }, {signal:this.events.signal});
      this.last = performance.now();
      this.timer = setInterval(() => {
        const now = performance.now();
        const delta = Math.min(now - this.last, 250);
        this.last = now;
        if (this.paused || document.hidden || this.contains(document.activeElement) || (matchMedia('(hover:hover)').matches && this.matches(':hover'))) return;
        this.elapsed += delta;
        this.progress.style.transform = 'scaleX(' + Math.min(this.elapsed / 6500, 1) + ')';
        if (this.elapsed >= 6500) this.next();
      }, 80);
      this.editorHandler = (event) => {
        const index = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
        if (index >= 0) { this.paused = true; this.show(index); this.sync(); }
      };
      this.addEventListener('shopify:block:select', this.editorHandler, {signal:this.events.signal});
    }
    sync() {
      this.control.setAttribute('aria-pressed', String(this.paused));
      this.control.setAttribute('aria-label', this.paused ? 'Play announcements' : 'Pause announcements');
    }
    next() { this.show((this.index + 1) % this.slides.length); }
    show(index) {
      const previous = this.slides[this.index];
      previous.classList.remove('is-active');
      previous.classList.add('is-exiting');
      previous.inert = true;
      previous.setAttribute('aria-hidden', 'true');
      clearTimeout(this.exitTimer);
      this.exitTimer = setTimeout(() => this.slides.forEach(slide => slide.classList.remove('is-exiting')), 450);
      this.index = index;
      const next = this.slides[index];
      next.classList.remove('is-exiting');
      next.inert = false;
      next.removeAttribute('aria-hidden');
      next.classList.add('is-active');
      this.elapsed = 0;
      this.progress.style.transition = 'none';
      this.progress.style.transform = 'scaleX(0)';
      this.resetFrame = requestAnimationFrame(() => {
        this.resetFrame = requestAnimationFrame(() => { this.progress.style.transition = ''; });
      });
      this.counter.textContent = String(index + 1).padStart(2, '0');
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.exitTimer);
      cancelAnimationFrame(this.resetFrame);
      this.events?.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-pantry-discovery"] && !Shopify.designMode) return;
  try {
    
function initPantryDiscovery(root){if(root.dataset.ready)return;root.dataset.ready='true';const tabs=[...root.querySelectorAll('[data-taste]')];const panels=[...root.querySelectorAll('[data-panel]')];const rail=root.querySelector('.hh-discovery__choices');const prev=root.querySelector('[data-taste-prev]');const next=root.querySelector('[data-taste-next]');const count=root.querySelector('[data-taste-count]');function nav(){prev.disabled=rail.scrollLeft<4;next.disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-4;const step=tabs[0]?.offsetWidth+14||1;count.textContent=String(Math.min(tabs.length,Math.round(rail.scrollLeft/step)+1)).padStart(2,'0')+' / '+String(tabs.length).padStart(2,'0')}prev.addEventListener('click',()=>rail.scrollBy({left:-rail.clientWidth*.82,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));next.addEventListener('click',()=>rail.scrollBy({left:rail.clientWidth*.82,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));rail.addEventListener('scroll',nav,{passive:true});new ResizeObserver(nav).observe(rail);nav();function select(tab,focus){tab.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});panels.forEach(p=>{p.hidden=p.dataset.panel!==tab.dataset.taste});if(focus)tab.focus()}tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab,false));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();select(tabs[next],true)}})});panels.forEach(panel=>{const items=[...panel.querySelectorAll('[data-discovery-product]')];const refresh=panel.querySelector('[data-refresh]');let offset=0;refresh.hidden=items.length<=3;refresh.addEventListener('click',()=>{offset=(offset+3)%items.length;const visible=new Set([0,1,2].map(i=>(offset+i)%items.length));items.forEach((item,i)=>{item.hidden=!visible.has(i);item.style.order=String((i-offset+items.length)%items.length)});panel.querySelector('.hh-discovery__products').scrollLeft=0;panel.querySelector('[data-taste-status]').textContent=items.filter((_,i)=>visible.has(i)).map(item=>item.querySelector('h4').textContent).join(', ')})})}document.querySelectorAll('[data-discovery]').forEach(initPantryDiscovery);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-discovery]').forEach(initPantryDiscovery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-pantry-edit-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hh-edit-rail')) {
  customElements.define('hh-edit-rail', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'rail' || this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.hh-edit-deck__track');
      this.nav = this.querySelector('.hh-edit-deck__nav');
      this.buttons = Array.from(this.querySelectorAll('button[data-direction]'));
      this.update = () => {
        const end = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.max(0, this.track.scrollLeft);
        this.nav.hidden = end < 2;
        this.buttons[0].disabled = position < 2;
        this.buttons[1].disabled = position >= end - 2;
      };
      this.handleClick = (event) => {
        const button = event.target.closest('button[data-direction]');
        if (!button || !this.contains(button)) return;
        const card = this.track.querySelector('article');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        this.track.scrollBy({left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.addEventListener('click', this.handleClick);
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      if (!this.ready) return;
      this.removeEventListener('click', this.handleClick);
      this.track.removeEventListener('scroll', this.update);
      this.observer.disconnect();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hh-welcome-benefits"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hh-welcome-copy')) {
 customElements.define('hh-welcome-copy', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.button = this.querySelector('button');
   this.handler = async () => {
    let copied = false;
    try { if (navigator.clipboard && window.isSecureContext) { await navigator.clipboard.writeText(this.button.dataset.code); copied = true; } } catch (error) {}
    if (!copied) {
     const field = document.createElement('textarea');
     field.value = this.button.dataset.code; field.setAttribute('readonly',''); field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
     document.body.appendChild(field); field.select(); field.setSelectionRange(0,field.value.length);
     try { copied = document.execCommand('copy'); } catch (error) {}
     field.remove(); this.button.focus({preventScroll:true});
    }
    const status = this.querySelector('[aria-live]');
    if (copied) { status.textContent = status.dataset.copied; this.button.dataset.copied = 'true'; clearTimeout(this.timer); this.timer = setTimeout(() => { status.textContent = ''; delete this.button.dataset.copied; },2000); }
   };
   this.button.addEventListener('click',this.handler);
  }
  disconnectedCallback() { if (!this.ready) return; this.button.removeEventListener('click',this.handler); clearTimeout(this.timer); this.ready=false; }
 });
}

  } catch(e) { console.error(e); }
})();
})();
